export default __webpack_public_path__ + "static/media/fond-2.62972d8f.jpg";